import React from 'react'

const Contact = () => {
  return (
    <div>
      <h4>
              Laptop Shopping Cart .
                <br/><br/>
               <i> 
                All types of laptops available <br/>
                Rajkot-Morbi Road, Rajkot 360 003 Gujarat, India<br/>
                Email : info@myshoppingcartlaptop.ac.in<br/>
                Landline : (+91) 281 - 7123456<br/>
              </i>
            </h4>
    </div>
  )
}

export default Contact